import { setInteractionError } from '@atlassian/react-ufo/set-interaction-error';

export const setUFOInteractionErrorCheck = (ufoName: string = '') => {
  if (ufoName) {
    setInteractionError(ufoName, {
      errorMessage: `${ufoName} error`,
      name: `${ufoName} error`,
    });
  }
};
